import { ResponseData, Err } from 'types';

import { http } from '.';

export const getInvoiceNumbers = async () => {
  return await http.get<Err, ResponseData<any[]>>(`InvoiceNumberGeneration`);
};

export const updateInvoiceNumbers = async (payload) => {
  return await http.put<Err, ResponseData<any[]>>(
    `InvoiceNumberGeneration`,
    payload
  );
};

export const createInvoiceNumbers = async (payload) => {
  return await http.post<Err, ResponseData<any[]>>(
    `InvoiceNumberGeneration`,
    payload
  );
};
